import i18n from '@/utils/i18n';
import React from 'react';
import { CorrectionInboundItemSearchContent } from './correction-item-search-content';
import { ORDER_INBOUNDS_ROUTES } from '@/navigators/routes';
import { OrderInboundsStackParams } from '@/navigators/types';
import { PageContainer } from '@/components/page-container';
import { StackScreenProps } from '@react-navigation/stack';
import { StyleSheet, View } from 'react-native';

type Props = StackScreenProps<
  OrderInboundsStackParams,
  ORDER_INBOUNDS_ROUTES.CorrectionSearch
>;

export const CorrectionItemSearchScreen: React.FC<Props> = ({
  route,
  navigation,
}) => {
  const alternativeMatches = route.params.alternativeMatches;
  const previousMatches = route.params.previousMatches;
  const savedVariantPackOrderCountsMap =
    route.params.savedVariantPackOrderCountsMap;
  return (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        onBackPress: () => {
          navigation.goBack();
        },
        showBackButton: true,
        showShadow: true,
        title: i18n.t('search'),
      }}
    >
      <View style={styles.container}>
        <CorrectionInboundItemSearchContent
          alternativeMatches={alternativeMatches}
          headerMessage={route.params.headerMessage}
          onItemCorrection={route.params.selectItem}
          previousMatches={previousMatches}
          savedVariantPackOrderCountsMap={savedVariantPackOrderCountsMap}
          variantPackUUID={route.params.initialVariantPackUUID}
        />
      </View>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 16,
  },
});
